module.exports = __webpack_public_path__ + "img/icon_tutorial.45f8efc1.svg";